import { render, staticRenderFns } from "./AddSub.vue?vue&type=template&id=21cabb3c&scoped=true&"
import script from "./AddSub.vue?vue&type=script&lang=js&"
export * from "./AddSub.vue?vue&type=script&lang=js&"
import style0 from "./AddSub.vue?vue&type=style&index=0&id=21cabb3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cabb3c",
  null
  
)

export default component.exports